// Module
var code = "<div class=\"vertical-scroll-container\"> <account-login-component></account-login-component> </div> ";
// Exports
module.exports = code;